import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DialogService } from '../../../services/modal-dialogs';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ssApiService } from '../../../services/ss-api.service';
import { LogsResponse } from '../../../models/ss-api/responses/logs.response';
import { LicenseManager } from '../../../managers/License.manager';
import { KeyValuePair } from '../../../models/KeyValuePair';
import { NoteTypes, Note } from '../../../models/domain/note';
import { NoteManagerConstructor } from '../../../managers/note.manager';
import { NoteManager } from '../../../managers/note.manager';
import { MemberEventsService } from '../../../services/member.events.service';
import { AdminLogItem, AdminLogItemArray } from '../../../models/domain/admin.log.item';
import { Subscription } from 'rxjs';
import { EntityChangedArgs } from '../../../managers/manager.base';
import { MemberLogItemArray } from '../../../models/domain/member.log.item';
import { WindowSettings } from '../../../../app/services/window-dialogs/window.settings';
import { WindowTypes, WindowActionTypes } from '../../../../app/services/window-dialogs/window.event';
import { WindowService } from '../../../../app/services/window-dialogs/window.service';
import { Router } from '../../../../../node_modules/@angular/router';
import { SortBot } from '../../../../app/helpers/sort';
import { NoteDetailsDialog } from '../../../dialogs/note.details/note.details.dialog';
import { MemberDashboardMembershipUserResponseArray } from '@models/ss-api/responses/member.dashboard.membership.user.response';
import { MemberDashboardMembershipResponseArray, MembershipStatusTypes } from '@models/ss-api/responses/member.dashboard.membership.response';
import { BillingCycleTypes } from '@models/domain/invoice';

@Component({
    selector: 'member-memberships',
    templateUrl: './member.memberships.component.html',
    styleUrls: ['./member.memberships.component.scss']
})
export class MemberMembershipsComponent implements OnInit, OnDestroy {
    @Input('IsBusy') IsBusy: boolean;
    @Input('MemberID') MemberID: number;
    @Input('Memberships') Memberships: MemberDashboardMembershipResponseArray;
    @Input('MembershipUsers') MembershipUsers: MemberDashboardMembershipUserResponseArray;
    
    @Output('onRefresh') onRefresh: EventEmitter<string> = new EventEmitter();
    @Output() refreshEvent = new EventEmitter();

    activeTab: string = "Users";

    UserSearch: String;
    MembershipSearch: String;

    userResultRows: number = 25;
    userFirstResult: number = 0;
    userLastResult: number = 24;

    membershipsResultRows: number = 25;
    membershipsFirstResult: number = 0;
    membershipsLastResult: number = 24;

    constructor(private api: ssApiService, private dialogService: DialogService, private sweetAlertService: SweetAlertService, private memberEvents: MemberEventsService, private windowService: WindowService, private router: Router) { }

    ngOnInit() {

    }

    ngOnDestroy() {

    }

    paginateUserLogs(e) {
        this.userFirstResult = e.page * e.rows;
        this.userLastResult = this.userFirstResult + e.rows;
    }

    paginateMembershipLogs(e) {
        this.membershipsFirstResult = e.page * e.rows;
        this.membershipsLastResult = this.membershipsFirstResult + e.rows;
    }

    BillingCycleTypeToString(type: BillingCycleTypes): string {
        return BillingCycleTypes[type];
    }

    MembershipStatusTypeToString(type: MembershipStatusTypes): string {
        return MembershipStatusTypes[type];
    }
}
